import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";

export const guidEmpty = "00000000-0000-0000-0000-000000000000";

export const getParentPath = () => {
  const { hash } = window.location;
  const url = hash.split("/");
  const finalPath = "/" + url[1];
  return finalPath;
};

export const getCurrentPath = () => {
  const { hash } = window.location;
  const url = hash.split("/");
  const list = url[3].split("?");
  const currentPath = "/" + url[2] + "/" + list[0];
  return currentPath;
};
export const getStatusApproval = (url) => {
  let statusData = [];
  const type = SplitLink(url);
  switch (type) {
    case "list":
      statusData = [0, 1];
      break;
    case "list?q=pending":
      statusData = [0, 1];
      break;

    case "list?q=approved":
      statusData = [2];
      break;
    default:
      statusData = [0, 1];
      break;
  }
  return statusData;
};
export const validateRegexTimeString = (value) => {
  const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
  return timeRegex.test(value);
};

export const convertFileToExcel = (data, type) => {
  // convert data to array butter then Blob
  const rels = new Blob([data], {
    type: type,
  });
  const relsUrl = URL.createObjectURL(rels);
  return relsUrl;
};
export const handleCheckDisableButton = (selectedItems, setIsDisable, user) => {
  if (selectedItems.length === 0) {
    setIsDisable(true);
    return true;
  }

  // if in selectedItems have item is not allow approve => disable button
  const isNotAllowApprove = selectedItems.filter(
    (item) => !item?.IsAllowApprove
  ).length;
  if (isNotAllowApprove > 0) {
    setIsDisable(true);

    return true;
  }

  setIsDisable(false);
  return false;
  // if (isNotAllowApprove === 1) {
  //   setIsDisable(true);

  //   return true;
  // }
  // setIsDisable(false);
  // return false;
  // selectedItems.map((item) => {
  //   if (
  //     // item.ApprovalStatus !== 0 &&
  //     // item.ApprovalStatus !== 1 &&
  //     // (item.RequestStatus === 0 || item.RequestStatus === 1)
  //     !item?.IsAllowApprove
  //   ) {
  //     setIsDisable(true);
  //     return true;
  //   }
  //   setIsDisable(false);
  //   return false;
  // });
};

export const changeColor = (payload) => {
  switch (payload) {
    case "New":
      return ".top-new-capu";
    case "In-Progress":
      return ".top-inprogress-capu";
    case "Approved":
      return ".top-approved-capu";
    case "Rejected":
      return ".top-rejected-capu";
    case "Canceled":
      return ".top-canceled-capu";
    default:
      return ".top-empty-capu";
  }
};
export const changeColorNumber = (payload) => {
  switch (payload) {
    case 0:
      return ".top-new-capu";
    case 1:
      return ".top-inprogress-capu";
    case 2:
      return ".top-approved-capu";
    case 3:
      return ".top-rejected-capu";
    case 4:
      return ".top-canceled-capu";
    default:
      return ".top-empty-capu";
  }
};

export const convertDateTime = (date) => {
  if (!date) {
    return "";
  }
  const dateObj = new Date(date);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  if (year === 1) return "";
  // return `${year}-${month}-${day}`;
  return `${day}/${month}/${year}`;
};

export const getDictionaryScreen = (itemCode) => {
  const dictionary = JSON.parse(localStorage.getItem("multiLang"));
  const data = dictionary.filter((item) => item.ItemCode === itemCode);
  const array = data.map((item) => item.Lang);
  return array[0];
};
export function checkTimeBlock(timeString) {
  const timeArray = timeString.split(":");
  if (timeArray[2] !== "00") return "Time is not on 00 seconds";
  if (parseInt(timeArray[1]) % 30 === 0) {
    return true;
  } else {
    return false;
  }
}
export const regExName =
  /^(?![0-9._])(?!.*[0-9._]$)(?!.*\d_)(?!.*_\d)[a-zA-Z0-9_]+$/;

export const changeDisplayedName = () => {
  const language = localStorage.getItem("locale");
  const object = {
    vi: "valueVi",
    en: "value",
    ja: "valueJa",
  };
  return object[language] ?? "value";
};

export const handleExportExcel = (dataGrid, fileName) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Main sheet");
  const data = dataGrid.current.instance;
  exportDataGrid({
    component: data,
    worksheet,
    autoFilterEnabled: true,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `${fileName}.xlsx`
      );
    });
  });
};
export const handleImportExcel = (dataGrid, fileName) => {};

export const getYears = () => {
  // get years from current year to previous year - 10
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear; i > currentYear - 15; i--) {
    years.push(i);
  }

  return years;
};
export const leaveType = [
  {
    id: 0,
    value: "Full day",
    valueVi: "Cả ngày",
    valueJa: "全日",
    default: "FullDay",
  },
  {
    id: 1,
    value: "First shift",
    valueVi: "Đầu ca",
    valueJa: "最初のシフト",
    default: "Before",
  },
  {
    id: 2,
    value: "End of shift",
    valueVi: "Cuối ca",
    valueJa: "シフト終了",
    default: "After",
  },
  // {
  //   id: 3,
  //   value: "Hour",
  //   valueVi: "Giờ",
  //   valueJa: "時間",
  //   default: "Hour",
  // },
];

export const listApprovalType = [
  {
    id: 0,
    value: "Time In/Out Adjustment",
    valueVi: "Điều chỉnh giờ vào/ra",
    valueJa: "時間調整",
    default: "AdjustTimeInOut",
  },
  // {
  //   id: 1,
  //   value: "Time Keeping Online",
  //   valueVi: "Chấm công trực tuyến",
  //   valueJa: "オンラインタイムカード",
  //   default: "CheckInOut",
  // },
  {
    id: 2,
    value: "Leave Registration",
    valueVi: "Đăng ký nghỉ",
    valueJa: "休暇登録",
    default: "Leave",
  },
  {
    id: 3,
    value: "Overtime Registration",
    valueVi: "Đăng ký tăng ca",
    valueJa: "残業登録",
    default: "Overtime",
  },
];

export const workingType = [
  {
    id: 0,
    value: "Normal",
    valueVi: "Ngày thường",
    valueJa: "通常",
    default: "Normal",
  },
  {
    id: 1,
    value: "Weekend",
    valueVi: "Cuối tuần",
    valueJa: "週末",
    default: "Weekend",
  },
  {
    id: 2,
    value: "Holiday",
    valueVi: "Ngày lễ",
    valueJa: "休日",
    default: "Holiday",
  },
  {
    id: 3,
    value: "Annual Leave",
    valueVi: "Nghỉ phép năm",
    valueJa: "年休",
    default: "AnnualLeave",
  },
  {
    id: 4,
    value: "Substitution",
    valueVi: "Thay thế",
    valueJa: "代替",
    default: "Substitution",
  },
  {
    id: 5,
    value: "Additional",
    valueVi: "Thêm",
    valueJa: "追加",
    default: "Additional",
  },
  {
    id: 6,
    value: "Company Holiday",
    valueVi: "Ngày lễ công ty",
    valueJa: "会社休日",
    default: "CompanyHoliday",
  },
];

export const OvertimeTypeEnum = [
  {
    id: 0,
    value: "Working Day",
    valueVi: "Ngày làm việc",
    valueJa: "出勤",
    default: "WorkingDay",
  },
  {
    id: 1,
    value: "Weekly Holiday",
    valueVi: "Ngày cuối tuần",
    valueJa: "週休",
    default: "WeeklyHoliday",
  },
  {
    id: 2,
    value: "Public Holiday",
    valueVi: "Ngày lễ chung",
    valueJa: "公休",
    default: "PublicHoliday",
  },
];

export const TransactionAdjustmentReason = [
  {
    id: "0",
    value: "Empty",
    valueVi: "Trống",
    valueJa: "空",
    default: "Empty",
  },
  {
    id: "10",
    value: "Forgot Card",
    valueVi: "Quên thẻ",
    valueJa: "カードを忘れた",
    default: "ForgotCard",
  },
  {
    id: "20",
    value: "Power Off",
    valueVi: "Tắt máy",
    valueJa: "電源を切った",
    default: "PowerOff",
  },
  {
    id: "30",
    value: "Device Error",
    valueVi: "Lỗi thiết bị",
    valueJa: "デバイスエラー",
    default: "DeviceError",
  },
  {
    id: "40",
    value: "Other",
    valueVi: "Khác",
    valueJa: "他の",
    default: "Other",
  },
];

export const ApprovalStatus = [
  {
    id: 0,
    value: "Rejected",
    valueVi: "Từ chối",
    valueJa: "拒否",
    default: "Rejected",
  },
  {
    id: 1,
    value: "Approved",
    valueVi: "Đã phê duyệt",
    valueJa: "承認",
    default: "Approved",
  },
];
export const AllowApprove = [
  {
    id: true,
    value: "Pending",
    valueVi: "Chưa duyệt",
    valueJa: "保留中",
    default: "Pending",
  },
  {
    id: false,
    value: "Approved",
    valueVi: "Đã duyệt",
    valueJa: "承認",
    default: "Approved",
  },
];
export const RequestStatus = [
  // {
  //   id: -1,
  //   value: "All",
  //   valueVi: "Tất cả",
  //   valueJa: "全て",
  //   default: "All",
  // },
  {
    id: 0,
    value: "New",
    valueVi: "Mới",
    valueJa: "新着",
    default: "New",
  },
  {
    id: 1,
    value: "In Progress",
    valueVi: "Trong tiến trình",
    valueJa: "進行中",
    default: "InProgress",
  },
  {
    id: 2,
    value: "Approved",
    valueVi: "Đã phê duyệt",
    valueJa: "承認済み",
    default: "Approved",
  },
  {
    id: 3,
    value: "Rejected",
    valueVi: "Bị từ chối",
    valueJa: "拒否された",
    default: "Rejected",
  },
  {
    id: 4,
    value: "Cancelled",
    valueVi: "Đã hủy",
    valueJa: "キャンセル",
    default: "Cancelled",
  },
];

export const PriorityColorData = [
  {
    text: "Leave",
    id: 1,
    color: "#1e90ff",
  },
  {
    text: "Overtime",
    id: 2,
    color: "#ff9747",
  },
  {
    text: "Holiday",
    id: 3,
    color: "#1e90ff",
  },
  {
    text: "Birthday",
    id: 4,
    color: "#56ca85",
  },
];

export const AdminNavigation = {
  Oid: "94c1275d-10ee-4d44-a288-244865e69b56",
  ItemCode: "P0050",
  text: "Setting",
  textVi: "Cài đặt",
  textJa: "設定",
  path: "/setting",
  icon: "/assets/icons/setting.svg",
  items: [
    {
      Oid: "d8752f54-d058-4741-af6e-d8a6d487dc39",
      ItemCode: "P0051",
      text: "Enum Setting",
      textVi: "Cài đặt Enum",
      textJa: "列挙型設定",
      path: "/enum-setting/list",
      icon: "",
    },
    {
      Oid: "2370db98-8970-4523-a9ca-689eb0db9409",
      ItemCode: "P0052",
      text: "Screen Setting",
      textVi: "Cài đặt Màn hình",
      textJa: "画面設定",
      path: "/screen-setting/list",
      icon: "",
    },
    {
      Oid: "e282aad3-9c70-4743-961a-37d783d4d2e8",
      ItemCode: "P0053",
      text: "Lookup Setting",
      textVi: "Cài đặt Lookup",
      textJa: "ルックアップ設定",
      path: "/lookup-setting/list",
      icon: "",
    },
    {
      Oid: "157a66f9-8b77-4a82-92a9-79bf22cde17d",
      ItemCode: "P0054",
      text: "Common Setting",
      textVi: "Cài đặt chung",
      textJa: "共通設定",
      path: "/common-setting/list",
      icon: "",
    },
    {
      Oid: "f297925b-3ef6-419a-934a-149e2139fc72",
      ItemCode: "P0055",
      text: "Navigation Setting",
      textVi: "Cài đặt Menu",
      textJa: "ナビゲーション設定",
      path: "/navigation-setting/list",
      icon: "",
    },
    {
      Oid: "FC8A9C7F-D544-4879-85D6-75551751AB66",
      ItemCode: "P0060",
      text: "Dictionary Setting",
      textVi: "Cài đặt Từ điển",
      textJa: "ナビゲーション設定",
      path: "/dictionary-setting/list",
      icon: "",
    },
  ],
};

export const TransactionTypeEnum = [
  {
    id: 0,
    value: "Leave",
    valueVi: "Nghỉ",
    valueJa: "年次休暇",
  },
  {
    id: 1,
    value: "Overtime",
    valueVi: "Tăng ca",
    valueJa: "残業",
  },
  {
    id: 2,
    value: "Transaction",
    valueVi: "Giao dịch",
    valueJa: "取引",
  },
  {
    id: 3,
    value: "Timekeeping",
    valueVi: "Chấm công",
    valueJa: "計時",
  },
  {
    id: 4,
    value: "Account",
    valueVi: "Tài khoản",
    valueJa: "Account",
  },
];

export const TransactionActionTypeEnum = [
  {
    id: 0,
    value: "Rejected",
    valueVi: "Từ chối",
    valueJa: "拒否",
    default: "Rejected",
  },
  {
    id: 1,
    value: "Approved",
    valueVi: "Đã phê duyệt",
    valueJa: "承認",
    default: "Approved",
  },
  {
    id: 2,
    value: "Create",
    valueVi: "Tạo mới",
    valueJa: "作成",
  },
  {
    id: 3,
    value: "Cancel",
    valueVi: "Hủy",
    valueJa: "キャンセル",
  },
];

export const PermissionPolicies = [
  {
    id: 1,
    value: "Is Administrative",
    valueVi: "Quản trị viên",
    valueJa: "管理者",
  },
  {
    id: 2,
    value: "Deny all by default",
    valueVi: "Từ chối tất cả theo mặc định",
    valueJa: "デフォルトですべて拒否",
  },
  {
    id: 3,
    value: "Read only all by default",
    valueVi: "Chỉ đọc tất cả theo mặc định",
    valueJa: "デフォルトではすべて読み取り専用",
  },
  {
    id: 4,
    value: "Allow all by default",
    valueVi: "Cho phép tất cả theo mặc định",
    valueJa: "デフォルトですべて許可",
  },
];

export const PaymentMethods = [
  {
    id: 0,
    value: "In Cash",
    valueVi: "Thanh toán tiền",
    valueJa: "現金で",
    default: "InCash",
  },
  {
    id: 1,
    value: "Compensation Leave",
    valueVi: "Nghỉ bù",
    valueJa: "代休",
    default: "CompensationLeave",
  },
];

export const SplitLink = (link) => {
  const arr = link.split("/");
  return arr[arr.length - 1];
};
